export const buttonSizeToLoaderSize = {
  small: '1.25rem',
  medium: '1.5rem',
  large: '2rem'
};